import * as v from "valibot";

// request
export const ConfigSchema = v.record(v.string(), v.any());
export type Config = v.InferOutput<typeof ConfigSchema>;

export const AddonSchema = v.object({
  Config: v.nullish(ConfigSchema),
  Name: v.nullish(v.string()),
  ReleaseName: v.nullish(v.string()),
  Namespace: v.nullish(v.string()),
  Type: v.string(),
  Version: v.nullish(v.string()),
});
export type Addon = v.InferOutput<typeof AddonSchema>;

export const RequestSchema = v.object({
  Addons: v.array(AddonSchema),
  ClusterId: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const DataSchema = v.object({
  ClusterId: v.string(),
  InstanceIds: v.array(v.string()),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
});
export type Response = v.InferOutput<typeof ResponseSchema>;
